import React from 'react';
import { Languages } from 'lucide-react';
import { Language } from '../../../types/matching';

interface ProfileLanguagesProps {
  languages: Language[];
}

export function ProfileLanguages({ languages }: ProfileLanguagesProps) {
  // Get level display info
  const getLevelInfo = (level: string) => {
    switch(level) {
      case 'native':
        return { label: 'Natif', color: 'from-primary-50 to-primary-100/50 dark:from-primary-900/20 dark:to-primary-900/10 border-primary-100/70 dark:border-primary-800/30', textColor: 'text-primary-600 dark:text-primary-400' };
      case 'fluent':
        return { label: 'Courant', color: 'from-emerald-50 to-emerald-100/50 dark:from-emerald-900/20 dark:to-emerald-900/10 border-emerald-100/70 dark:border-emerald-800/30', textColor: 'text-emerald-600 dark:text-emerald-400' };
      case 'intermediate':
        return { label: 'Intermédiaire', color: 'from-amber-50 to-amber-100/50 dark:from-amber-900/20 dark:to-amber-900/10 border-amber-100/70 dark:border-amber-800/30', textColor: 'text-amber-600 dark:text-amber-400' };
      default:
        return { label: 'Basique', color: 'from-gray-50 to-white dark:from-gray-900/20 dark:to-gray-800 border-gray-200/70 dark:border-gray-700/30', textColor: 'text-gray-600 dark:text-gray-400' };
    }
  };

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
        <div className="p-1.5 bg-primary-50 dark:bg-primary-900/20 rounded-lg">
          <Languages className="w-4 h-4 text-primary-500 dark:text-primary-400" />
        </div>
        <span>Langues</span>
      </h3>
      <div className="flex flex-wrap gap-2 sm:gap-3">
        {languages.length === 0 ? (
          <p className="text-sm text-gray-500 dark:text-gray-400 italic">
            Aucune langue renseignée
          </p>
        ) : (
          languages.map((lang) => {
            const levelInfo = getLevelInfo(lang.level);
            return (
              <div
                key={lang.code}
                className={`flex items-center gap-2 px-3 py-2 bg-gradient-to-br ${levelInfo.color} rounded-lg shadow-sm border`}
              >
                <Languages className="w-4 h-4 text-gray-500 dark:text-gray-400" />
                <div>
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300 mr-1">
                    {lang.name}
                  </span>
                  <span className={`text-xs ${levelInfo.textColor} font-medium`}>
                    ({levelInfo.label})
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}